import Vue from "vue";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingConfigurations: false,
      configurations: [],
    }),
    mutations: {
      setLoadingConfigurations(state, item) {
        state.loadingConfigurations = item
      },
      loadConfigurations(state, items) {
        state.configurations = items;
      },
    },
    actions: {
      async fetchConfigurations({ commit }, { from, to, country }) {
        commit("setLoadingConfigurations", true);

        let url = process.env.VUE_APP_HUB_API_HOST + `api/configurator-app/configurations`;

        const urlParams = {
          from: from,
          to: to,
        };

        if (country) {
          urlParams["country"] = country;
        }

        try {
          const response = await Vue.http.get(url, {
            headers: headers,
            params: urlParams
          });
          commit("loadConfigurations", response.data.configurations);
          commit("setLoadingConfigurations", false);
        } catch (error) {
          console.error("Error fetching configurations:", error);
          commit("setLoadingConfigurations", false);
          throw error;
        }
      },
      async downloadConfigurationPdf(context, id) {
        let url = process.env.VUE_APP_HUB_API_HOST + `api/configurator-app/configurations/${id}/pdf`;

        try {
          const response = await Vue.http.get(url, {
            headers: headers,
            responseType: "arraybuffer",
          });
          return response.body;
        } catch (error) {
          console.error("Error downloading configuration pdf:", error);
          throw error;
        }
      },
    }
}
